import * as Yup from 'yup'
import moment from 'moment'

export const ValidateSchemaPersonal = Yup.object().shape({
    contact: Yup.object().shape({
        first_name: Yup.string()
            .min(2, 'Имя должно содержать минимум 2 символа')
            .max(20, 'Имя не должно превышать 20 символов')
            .required('Имя является обязательным'),
        surname: Yup.string()
            .min(2, 'Фамилия должна содержать минимум 2 символа')
            .max(20, 'Фамилия не должна превышать 20 символов')
            .required('Фамилия является обязательной'),
    }),
    phone: Yup.string()
        .required('Телефон является обязательным полем')
        .matches(
            /^\+7-\d{3}-\d{3}-\d{2}-\d{2}$/,
            'Телефон должен быть в формате +7-XXX-XXX-XX-XX',
        ),
    email: Yup.string()
        .email('Введите корректный email')
        .required('Email является обязательным полем'),
    discount: Yup.number()
        .transform((_, originalValue) =>
            originalValue === '' ? undefined : Number(originalValue),
        )
        .typeError('Введите корректное число')
        .min(0, 'Скидка не может быть меньше 0%')
        .max(100, 'Скидка не может быть больше 100%'),
    additional_data: Yup.object({
        documents: Yup.object({
            issue_date: Yup.string().test(
                'not-in-future',
                'Дата выдачи указана некорректно',
                value => {
                    if (!value) return true

                    const date = moment(value, 'DD.MM.YYYY', true)

                    if (!date.isValid()) return false

                    return date.isSameOrBefore(moment(), 'day')
                },
            ),
            house_number: Yup.string()
                .nullable()
                .max(10, 'Номер дома не должен превышать 10 символов'),
            apartment_number: Yup.string()
                .nullable()
                .max(10, 'Номер квартиры не должен превышать 10 символов'),
        }),
    }),
})
